// removed by extract-text-webpack-plugin
module.exports = {"container":"_2SVI","inner":"_3YsX","img":"_1h4W","zoomIn":"tSra","zoomOut":"NYr5","iconBar":"_36rk","count":"Ugyv","close":"_2aI9","zoomIcons":"_3CyF","zoomInIcon":"KXTQ","zoomOutIcon":"p5Gx","previous":"hLaT","next":"LCji"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pagescreen/imageviewer/style.css
// module id = 412
// module chunks = 9